import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90 shadow-soft hover:shadow-card transition-all duration-300",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90 transition-colors duration-200",
        outline: "border border-primary/30 bg-transparent text-primary hover:bg-primary/10 hover:border-primary transition-all duration-300",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80 transition-colors duration-200",
        ghost: "hover:bg-muted hover:text-foreground transition-colors duration-200",
        link: "text-primary underline-offset-4 hover:underline",
        // Custom variants for this project
        hero: "bg-primary text-primary-foreground hover:bg-primary-dark shadow-card hover:shadow-elevated transition-all duration-300 hover:-translate-y-0.5",
        "hero-outline": "border-2 border-primary/40 bg-transparent text-primary hover:bg-primary/10 hover:border-primary transition-all duration-300 hover:-translate-y-0.5",
        soft: "bg-primary-light text-primary-dark hover:bg-primary/20 transition-colors duration-300",
        accent: "bg-accent text-accent-foreground hover:bg-accent/80 transition-colors duration-200",
        whatsapp: "bg-[#25D366] text-white hover:bg-[#128C7E] shadow-soft hover:shadow-card transition-all duration-300",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-12 rounded-xl px-8 text-base",
        xl: "h-14 rounded-xl px-10 text-lg",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button, buttonVariants }